<template>
<div class="startwdr">

    <WaitMessage :ob="accob" />
    
    <div v-if="!accob.wait && !accob.message">
        <h2>Выберите способ выплаты вознаграждения</h2>
        <div class="do">Вознаграждение - <b>{{accob.claim.reward.sum}}р</b></div>
        <form @submit.prevent>

            <div v-for="(acc, index) in accob.accounts" :key="`${acc.type}-${acc.anumber}`" class="line">
                <input :id="`withdrawal-account-${index}`" type="radio" name="acc"
                    v-model="acc_calc" :disabled="!acc.is" :value="acc" />
                <div class="account-content">
                    <label :for="`withdrawal-account-${index}`">
                        <ShowAcc :acc="acc" />
                    </label>
                    <button type="button" class="btndot" v-if="'bank'==acc.type && !acc.doNotChange" @click="goadd">
                        {{acc.is ? 'Изменить счет' : 'Указать счет'}}
                    </button>
                    <div v-if="acc.denyReason" class="denyReason" v-html="acc.denyReason"></div>
                </div>
            </div>

            <ButMes @input="start" :ob="startob" text="Создать запрос на выплату" />

        </form>
    </div>
</div>
</template>

<style lang="scss" scoped>
.startwdr {
    .line {
        display: flex;
        align-items: center;
        gap: 10px;
        padding-bottom: 10px;
        > input { flex-shrink: 0; margin: 0; }
    }
    .account-content {
        min-width: 0;
        label { display: block; cursor: pointer; }
    }    
    .do { margin-bottom: 15px; }
    .denyReason { margin: 0 5px; color: #aa0000; }
}
</style>

<script setup>
import {ref, unref, computed, onMounted, reactive} from 'vue'
import {getWithdrawalAccounts, initiateWithdrawal} from '@/actions.js'
import { useRouter } from 'vue-router/composables'
import ButMes from '@/comp/Payout/ButMes.vue'
import WaitMessage from '@/comp/Payout/WaitMessage.vue'
import ShowAcc from '@/payout/ShowAcc.vue'

const router = useRouter();

const props = defineProps({
  claim_num: String, 
})

const accob = reactive({
  accounts : [],
  claim: null,
  wait: true,
  message: '',
})

const acc = ref(null) 
const acc_calc = computed({
    get() {
        return acc.value
    },
    set(val) {
        acc.value = val
    }
})

const goadd = () => {
    router.push({name: 'Manage'})
}


const load = () => {
    accob.accounts = null
    accob.claim = null
    accob.wait = true
    accob.message = ''
    const {claim_num} = props

    getWithdrawalAccounts({claim_num}).then( ({accounts, claim}) => {
      accob.wait = false
      accob.accounts = accounts
      accob.claim = claim
    }, message => {
      accob.wait = false
      accob.message = `Не удалось получить реквизиты для выплаты по ${claim_num}: ${message}`
    } )
}

const startob = reactive({
  wdr_sid : '',
  wait: false,
  message: '',
})


const start = () => {
    let account = unref(acc)
    if (!account || startob.wait) {
        if (!account) {
            startob.message  = 'Выберите способ'
        }
        return 
    }
    startob.wdr_sid = ''
    startob.wait = true
    startob.message = ''
    let {claim_num} = props
    initiateWithdrawal({claim_num, account }).then( ({wdr_sid})=>{
        startob.wdr_sid = wdr_sid
        startob.wait = false
        router.push({name: 'CheckDoc', query: {wdr_sid} })
    }, message => {
        startob.wait = false
        startob.message = `Не удалось: ${message}`
    } )
}

onMounted(load)


</script>
